import { connect } from 'react-redux';
import { actionCreators } from './actions';
import { HeaderPanelProps } from 'app/components/case-header-panel';
import { ComplexValue } from 'ui';
import { ConnectedCaseActionTypes } from 'app/components/connect-existing-cases/connect-existing-cases';
import { ApplicationState } from 'app/types-store';

export interface CallsToActionsProps extends Partial<HeaderPanelProps> {
  onChangeDraftConnections?: (params: { connectedCaseId: number; connectionTypeId: number; type: ConnectedCaseActionTypes }) => void;
  changingCaseStatus?: boolean;
  changingDraftConnection?: boolean;
}

export const withCallsToActions = (component: any) => {
   const stateToProps = (appState: ApplicationState): Partial<CallsToActionsProps> => {
    return {
      changingCaseStatus: appState?.caseArea?.changingCaseStatus,
      changingDraftConnection: appState?.caseArea?.changingDraftConnection
    };
  };  

  const dispatchToProps = (dispatch: any): CallsToActionsProps => {
    return {
      callsToActions: (caseId: number) => 
        dispatch(actionCreators.callsToActions(caseId)),
      
      onChangeCaseStatus: (caseId: number, status: ComplexValue<number>, allowWarnings: boolean = true) => 
        dispatch(actionCreators.onChangeCaseStatus(caseId, status, allowWarnings)),

      onChangeCaseConnection: ({ caseId, connectedCaseId, connectionTypeId,
        currentConnectedCases, allowWarnings = true, type, bowtie = false, instanceKey
      }: {
        caseId: number;
        connectedCaseId: number;
        connectionTypeId: number;
        allowWarnings: boolean;
        type: ConnectedCaseActionTypes;
        currentConnectedCases?: number[];
        bowtie?: boolean;
        instanceKey?: string;
      }) =>
        dispatch(actionCreators.onChangeCaseConnection(caseId, connectedCaseId, connectionTypeId, currentConnectedCases, type,
          allowWarnings, bowtie, instanceKey)),
      onChangeDraftConnections: ({ connectedCaseId, connectionTypeId, type }:
        { connectedCaseId: number; connectionTypeId: number; type: ConnectedCaseActionTypes }) =>
        dispatch(actionCreators.onChangeDraftConnections(connectedCaseId, connectionTypeId, type))
    };
    
  };

  return connect<any, any, any>(stateToProps, dispatchToProps)(component);
};
